<label class="file-field"
       *ngIf="!minimalDisplay || !file"
       [class.disabled]="isDisabled"
       (dragover)="onDragOver()"
       (dragleave)="onDragLeave()"
       (drop)="onDrop()">
  <i class="fa fa-light fa-paperclip" aria-hidden="true"></i>
  {{ 'FORM_GENERATOR.choose_or_drop' | translate }}
  <input type="file" [accept]="contentType" [disabled]="isDisabled" (change)="uploadFile($event)"/>
</label>
<div *ngIf="file" class="form-control">
  <label>
    {{file.name}}
  </label>
  <button
    type="button"
    title="{{'DIALOG.confirm_remove_file' | translate}}"
    [attr.test-id]="'remove-uploaded_file'"
    class="btn btn-xs remove-file-btn pull-right"
    [disabled]="isDisabled"
    (click)="deleteFile()">
    <i class="fa fa-light fa-trash-alt" aria-hidden="true">
    </i>
  </button>
</div>
<ul class="error-list" [attr.data-hidden]="!isMaxFileSize && isFileFormatValid">
  <li
    *ngIf="isMaxFileSize">{{ 'FORMS.VALIDATORS.file_size_XMB' | translate : {size: (maxFileSize / 1024 / 1024).toFixed()} }}</li>
  <li *ngIf="!isFileFormatValid">{{ 'FORMS.VALIDATORS.invalidFormat' | translate }}</li>
</ul>
